var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 74,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.927 53.726a3.136 3.136 0 01-3.94 2.035L25.67 40.073a3.134 3.134 0 01-2.037-3.936L34.102 3.286a3.136 3.136 0 013.94-2.036l49.316 15.69a3.134 3.134 0 012.038 3.937L78.927 53.726z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.927 53.726a3.136 3.136 0 01-3.94 2.035L25.67 40.073a3.134 3.134 0 01-2.037-3.936L34.102 3.286a3.136 3.136 0 013.94-2.036l49.316 15.69a3.134 3.134 0 012.038 3.937L78.927 53.726z",
    stroke: "#376F66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1 3.286l-.149.466L53.778 26.4a6.276 6.276 0 006.187 1.967l29.282-7.026.148-.464a3.134 3.134 0 00-2.038-3.937L38.041 1.25a3.137 3.137 0 00-3.94 2.036",
    fill: "#E7F9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1 3.286l-.149.466L53.778 26.4a6.276 6.276 0 006.187 1.967l29.282-7.026.148-.464a3.134 3.134 0 00-2.038-3.937L38.041 1.25a3.137 3.137 0 00-3.94 2.036zM23.666 38.614L51.47 23.761M77.376 55.549l-14-27.999",
    stroke: "#376F66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.47 70.453c0 1.712-19.694 3.102-43.986 3.102-24.295 0-43.989-1.39-43.989-3.102 0-1.714 19.694-3.105 43.989-3.105 24.292 0 43.986 1.39 43.986 3.105",
    fill: "#FEF0DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.67 68.32H12.593a3.599 3.599 0 01-3.6-3.596v-36.24a3.597 3.597 0 013.6-3.596H72.67c1.987 0 3.6 1.61 3.6 3.596v36.24a3.6 3.6 0 01-3.6 3.597",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.67 68.32H12.593a3.599 3.599 0 01-3.6-3.596v-36.24a3.597 3.597 0 013.6-3.596H72.67c1.987 0 3.6 1.61 3.6 3.596v36.24a3.6 3.6 0 01-3.6 3.597zM17.274 32.126h10.35M17.274 37.297h10.35M17.274 42.468h10.35",
    stroke: "#376F66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F9F4",
    d: "M54.534 46.603h12.42V32.126h-12.42z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#376F66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M54.534 46.603h12.42V32.126h-12.42zM32.799 60.047h20.7M34.87 54.876h16.56"
  }))));
}
export default SvgIconEmail;